var map = {
	"./interview-hero-img-2.webp": 3701,
	"./interview-laptop-any-job.webp": 3706,
	"./interview-laptop-compiler.webp": 3707,
	"./interview-laptop-hr.webp": 3704,
	"./interview-laptop-result-cut.webp": 3708,
	"./interview-laptop-result.webp": 3816,
	"./interview-laptop-technical.webp": 3705,
	"./interview-laptop-web.webp": 3817,
	"./interview-laptop.webp": 3493,
	"./interview-techs-2.webp": 3818,
	"./techs-icons/ds-is-icon-python-scroll.webp": 3709,
	"./techs-icons/ds-is-icon-r-scroll.webp": 3710,
	"./techs-icons/ds-is-icon-sql-scroll.webp": 3711,
	"./techs-icons/python-hero.webp": 3702,
	"./techs-icons/python-talk-is-cheap.webp": 3819,
	"./techs-icons/r-hero.webp": 3703,
	"./techs-icons/r-talk-is-cheap.webp": 3820,
	"./techs-icons/slqlite-talk-is-cheap.webp": 3821
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5150;